/* eslint-disable */

import { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Box from '@mui/material/Box'
import { MainLayout } from 'views/layouts'
import {
  Container,
  Content,
  SelectorsContainer,
  FooterContent,
  HeaderContainer,
  HeaderTextBlock,
  IntroBlock,
  IntroTitle,
  IntroText,
  OptionsGrid,
  OptionCard,
  OptionEyebrow,
  OptionHeader,
  OptionTitle,
  OptionDescription,
  OptionMeta,
  OptionBadge,
  OptionIndicator,
  CopyBlock,
  OptionSupportBlock,
  StepEyebrow,
  StepDescription,
} from './styled'
import Stepper from 'views/components/Stepper'
import { H2 } from 'views/components/UI/Text'
import { Button, BackButton } from 'views/components/UI/Buttons'
import ModalLoader from 'views/components/UI/ModalLoader/modal-loader'
import ModalConfirmDeleteEditedRoleFamily from './modal-confirm-delete-edited-rolefamily'
import ModalConfirmCopyProcess from './modal-confirm-copy-process'
import { platformAdminRoutes } from 'router/routes'
import InfoRoleFamilyContainer from 'views/containers/RoleFamily/infoRoleFamily'
import AlertComponent from 'views/components/Alert'
import {
  stepOneSelector,
  stepTwoSelector,
  setStepTwoTrigger,
  setStepThree,
  setStepFour,
  setLoading as setLoadingProcess,
  stepFourSelector,
  stepFiveSelector,
  setUserListAdded,
  cleanStepsFromThree,
} from 'ducks/createProcess'
import { RoleFamily as IRoleFamily, Level as ILevel } from 'types/common'
import { STEPS_NEW_PROCESS } from '../constants'
import { generalDataSelector } from 'ducks/auth'
import getRoleFamilyByFilters from 'services/rolFamily/fetchGetRoleFamilyByLevel'
import { parseQuadrantFullNameToShortName } from 'utils/common'
import { User } from '../Users/constants'
import useDeleteUsersInProcess from 'hooks/process/useDeleteUsersInProcess/use-delete-users-in-process'
import { deleteModelProcessAssociation } from 'views/screens/super-admin/homologation-skills/services/deleteModelProcessAssociation'
import { useGetCreditsAvailables } from 'hooks/inventory/useInventory'
import { useTranslation } from 'react-i18next'
import { useNotification } from 'lib/context/notification.context'
import {
  copyProcessConfiguration,
  getProcessDetail,
  updateProcess,
} from 'services/common/process/createProcess/create-process-service'
import { userSelector } from 'ducks/user'
import getProcessByCompany from 'services/companies/getProcessByCompany'
import SelectSearch from 'views/screens/Platform-administrator/Analytics/selectSearch'
import { useFinishProcess } from 'hooks/process/useFinishProcess/useFinishProcess'

type ProcessOption = {
  value: number
  label: string
}

type ConfigurationOption = {
  key: 'ai' | 'manual' | 'role-family' | 'copy'
  eyebrow: string
  title: string
  description: string
  accent: 'pink' | 'blue' | 'slate'
  badge?: string
}

function RoleFamily() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { data: generalData } = useSelector(generalDataSelector)
  const { companyId, userId } = useSelector(userSelector)
  const stepOneData = useSelector(stepOneSelector)
  const stepTwoData = useSelector(stepTwoSelector)
  const stepFourData = useSelector(stepFourSelector)
  const stepFiveData = useSelector(stepFiveSelector)
  const isRoleFamilySelected = stepTwoData?.isRoleFamilySelected
  const isAiConfigurationActive = stepTwoData?.configurationMode === 'ai_ideal_profile'
  const levelOptions = generalData?.level
  const hasEditedRoleFamily = stepFourData?.isEditingRoleFamily
  const { getWarning } = useNotification()
  const { handleFinishProcess } = useFinishProcess()

  const { deleteUsersInProcess, deleteTestsInProcess } = useDeleteUsersInProcess()

  const [showAlert, setShowAlert] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [showModalConfirmDeleteEditedRoleFamily, setShowModalConfirmDeleteEditedRoleFamily] = useState<boolean>(false)
  const [showConfirmCopyModal, setShowConfirmCopyModal] = useState<boolean>(false)

  const [nameRoleFamilySelected, setNameRoleFamilySelected] = useState<string>(stepTwoData?.roleFamilyName || '')
  const [editingRoleFamily, setEditingRoleFamily] = useState(false)
  const [isSelectedRoleFamily, setIsSelectedRoleFamily] = useState<boolean | null>(
    typeof isRoleFamilySelected === 'boolean' ? isRoleFamilySelected : null
  )
  const [isAiConfigurationSelected, setIsAiConfigurationSelected] = useState<boolean>(isAiConfigurationActive)
  const [isCopyConfigurationSelected, setIsCopyConfigurationSelected] = useState<boolean>(false)
  const [roleFamilies, setRoleFamilies] = useState<IRoleFamily[]>([])
  const [roleFamily, setRoleFamily] = useState<any>()
  const [processesToCopy, setProcessesToCopy] = useState<ProcessOption[]>([])
  const [selectedProcessToCopy, setSelectedProcessToCopy] = useState<number | string>('')
  const [pendingProcessToCopy, setPendingProcessToCopy] = useState<ProcessOption | null>(null)

  const { refreshCredits } = useGetCreditsAvailables(stepOneData.inventoryTypeId)

  const configurationOptions: ConfigurationOption[] = [
    {
      key: 'ai',
      eyebrow: 'Opción 1',
      title: 'Generador de perfil ideal con IA Bluesite Lumina',
      description:
        'Carga el perfil del cargo y deja que Bluesite Lumina sugiera Betesa y 3D Skills como punto de partida editable.',
      accent: 'pink',
      badge: 'Nuevo',
    },
    {
      key: 'manual',
      eyebrow: 'Opción 2',
      title: 'Configuración desde cero',
      description:
        'Define manualmente las pruebas, el perfil ideal y la configuración paso a paso.',
      accent: 'pink',
    },
    {
      key: 'role-family',
      eyebrow: 'Opción 3',
      title: 'Familia de rol',
      description:
        'Usa una parametrización ya estructurada por familia de rol y acelera la configuración del proceso.',
      accent: 'blue',
    },
    {
      key: 'copy',
      eyebrow: 'Opción 4',
      title: 'Copiar otro proceso',
      description:
        'Toma una parametrización existente como base y replica pruebas, perfil ideal y configuración del proceso.',
      accent: 'slate',
    },
  ]

  const currentStepIndex = editingRoleFamily ? 3 : 1
  const currentStepTitle = STEPS_NEW_PROCESS[currentStepIndex]
  const currentStepDescription =
    currentStepIndex === 1
      ? 'Define la ruta con la que quieres construir este proceso antes de avanzar a pruebas y configuración.'
      : 'Ajusta el perfil ideal y los parámetros del proceso para dejarlo listo antes de cargar usuarios.'

  useEffect(() => {
    if (stepFiveData?.userListAdded) {
      dispatch(setUserListAdded([]))
      const idUsersToDelete = stepFiveData?.userListAdded
        .map((user: User) => user.id)
        .filter((id: number) => id !== undefined)

      if (idUsersToDelete.length > 0) {
        deleteUsersInProcess(stepOneData.processId, idUsersToDelete)
      }
      refreshCredits()
    }
  }, [])

  useEffect(() => {
    const levelSelected = levelOptions?.find((level: ILevel) => level.id === stepOneData.level)?.name || ''
    getRoleFamilyByFilters({ level: levelSelected }).then((res) => {
      if (res.status === 'OK') {
        setRoleFamilies(res.roleFamilies)
      }
    })
  }, [stepTwoData, stepOneData, generalData, levelOptions])

  useEffect(() => {
    const fetchProcessesToCopy = async () => {
      if (!companyId || !userId || !stepOneData.processId) {
        setProcessesToCopy([])
        return
      }

      try {
        const response = await getProcessByCompany(companyId, userId)

        const rawProcesses = Array.isArray((response as any)?.data?.processes)
          ? (response as any).data.processes
          : []

        if (response?.status !== 'OK' || rawProcesses.length === 0) {
          setProcessesToCopy([])
          return
        }

        const currentProcessId = Number(stepOneData.processId)
        const formattedProcesses = rawProcesses
          .filter((processItem: any) => {
            const processId = Number(processItem.id ?? processItem.process_id)
            return processId !== currentProcessId
          })
          .map((processItem: any) => ({
            value: processItem.id ?? processItem.process_id,
            label: processItem.name ?? processItem.process_name,
          }))

        setProcessesToCopy(formattedProcesses)
      } catch (error) {
        console.error('Error fetching visible processes to copy', error)
        setProcessesToCopy([])
      }
    }

    fetchProcessesToCopy()
  }, [companyId, stepOneData.processId, userId])

  useEffect(() => {
    if (!isRoleFamilySelected) {
      setNameRoleFamilySelected('')
      setIsSelectedRoleFamily(null)
    }
  }, [isRoleFamilySelected])

  useEffect(() => {
    if (stepTwoData?.configurationMode === 'ai_ideal_profile') {
      setIsAiConfigurationSelected(true)
      setIsSelectedRoleFamily(null)
      setIsCopyConfigurationSelected(false)
    }
  }, [stepTwoData?.configurationMode])

  useEffect(() => {
    if (isAiConfigurationActive) {
      navigate(platformAdminRoutes.IdealProfileGeneratorAi, { replace: true })
    }
  }, [isAiConfigurationActive, navigate])

  const handleCreateProcessFromScratch = async () => {
    // Limpiar estados de pasos posteriores antes de crear proceso desde cero
    dispatch(cleanStepsFromThree())

    // Eliminar tests y modelo de proceso existentes antes de continuar
    try {
      await deleteTestsInProcess(stepOneData.processId)
      await deleteModelProcessAssociation(stepOneData.processId)
    } catch (error) {
      console.error('Error al limpiar tests y modelo:', error)
    }

    dispatch(setStepTwoTrigger.run({ isRoleFamilySelected: false, processId: stepOneData.processId }))
    navigate(platformAdminRoutes.SelectTestsType)
  }

  const handleCreateProcessWithAI = async () => {
    dispatch(cleanStepsFromThree())
    dispatch(
      setStepTwoTrigger.run({
        isRoleFamilySelected: false,
        processId: stepOneData.processId,
        configurationMode: 'ai_ideal_profile',
      })
    )
    navigate(platformAdminRoutes.IdealProfileGeneratorAi)
  }

  const handleCreateProcessWithRoleFamily = async () => {
    const profileValueEdited = stepFourData.betesaIdealProfile?.profileValues
      ? stepFourData.betesaIdealProfile?.profileValues.map((item: any) => {
          return {
            quadrant: parseQuadrantFullNameToShortName(item.quadrant),
            priority: item.priority,
            min: item.min,
            max: item.max,
          }
        })
      : roleFamily?.ideal_profile?.map((item: any) => {
          return {
            quadrant: parseQuadrantFullNameToShortName(item.quadrant),
            priority: item.priority,
            min: item.min,
            max: item.max,
          }
        })

    const competencesIdealProfile = stepFourData.competencesIdealProfile
      ? stepFourData.competencesIdealProfile?.map((item: any) => {
          const formattedItem: any = {
            skill_id: item.skill_id || item.id,
          }

          if (Number(item.weight) > 0) {
            formattedItem.weight = Number(item.weight)
          }

          return formattedItem
        })
      : roleFamily?.competence_skills?.map((item: any) => {
          const formattedItem: any = {
            skill_id: item.skill_id || item.id,
          }

          if (Number(item.weight) > 0) {
            formattedItem.weight = Number(item.weight)
          }

          return formattedItem
        })
    const sanitizedCompetencesIdealProfile = (competencesIdealProfile || []).filter(
      (item: any) => Number(item.skill_id) > 0
    )

    const betesaIdealProfile = {
      alertLevelId: stepFourData?.betesaIdealProfile?.alertLevelId || roleFamily?.ideal_profile[0]?.alert_level_range,
      profileValues: profileValueEdited,
      betesaSkills: [],
    }

    if (loading) {
      return
    }
    setLoading(true)

    try {
      dispatch(
        setStepTwoTrigger.run({
          isRoleFamilySelected: true,
          processId: stepOneData.processId,
          roleFamilyName: nameRoleFamilySelected,
        })
      )

      await deleteTestsInProcess(stepOneData.processId)
      await deleteModelProcessAssociation(stepOneData.processId)

      const dataUpdateStepThree = {
        processId: stepOneData.processId,
        onlineCourse: false,
        useBetesaTest: roleFamily.ideal_profile.length > 0,
        useSkillsTest: roleFamily.competence_skills.length > 0,
      }

      const stepThreeResponse = await updateProcess(stepOneData.processId, {
        test_selection: {
          online_course: dataUpdateStepThree.onlineCourse,
          betesa_test: dataUpdateStepThree.useBetesaTest,
          competences_test: dataUpdateStepThree.useSkillsTest,
          test_360: false,
        },
      })

      if (stepThreeResponse.status === 'error') {
        const stepThreeMessage =
          (stepThreeResponse as any).message || stepThreeResponse.error || 'No fue posible crear las pruebas para el proceso'
        getWarning(String(stepThreeMessage))
        return
      }

      dispatch(setStepThree(dataUpdateStepThree as any))

      const dataUpdateStepFourStore: any = {
        processId: stepOneData.processId,
        isEditingRoleFamily: Object.keys(stepFourData).length > 0,
      }

      const dataUpdateStepFourApi: any = {}

      if (betesaIdealProfile.alertLevelId?.length > 0) {
        const normalizedAlertRange = [...betesaIdealProfile.alertLevelId]
          .map((item: any) => Number(item))
          .filter((item: number) => !Number.isNaN(item))
          .sort((a: number, b: number) => a - b)
        if (normalizedAlertRange.length === 0) {
          getWarning('No fue posible determinar el rango de alerta para BETESA')
          return
        }

        dataUpdateStepFourStore.betesaIdealProfile = betesaIdealProfile
        dataUpdateStepFourApi.betesa_ideal_profile = {
          alert_level_range: [
            normalizedAlertRange[0],
            normalizedAlertRange[normalizedAlertRange.length - 1],
          ],
          profile_values: profileValueEdited,
          betesa_skills: [],
        }
      }

      if (sanitizedCompetencesIdealProfile.length > 0) {
        dataUpdateStepFourStore.competencesIdealProfile = sanitizedCompetencesIdealProfile
        dataUpdateStepFourApi.competences_ideal_profile = sanitizedCompetencesIdealProfile
      }

      let stepFourResponse: any = { status: 'OK' }

      if (Object.keys(dataUpdateStepFourApi).length > 0) {
        stepFourResponse = await updateProcess(stepOneData.processId, {
          ideal_profile: dataUpdateStepFourApi,
        })
      }

      if (stepFourResponse.status === 'error') {
        const stepFourMessage =
          (stepFourResponse as any).message || stepFourResponse.error || 'No fue posible guardar el perfil ideal'
        getWarning(String(stepFourMessage))
        return
      }

      dispatch(setStepFour(dataUpdateStepFourStore))
      navigate(platformAdminRoutes.CreateUsers)
    } catch (error: any) {
      const backendMessage = error?.response?.data?.message
      getWarning(backendMessage || error?.message || 'Ocurrio un error al guardar la familia de rol')
    } finally {
      setLoading(false)
    }
  }

  const handleCopyConfiguration = async (sourceProcessId: string | number) => {
    if (!sourceProcessId || !stepOneData.processId) return

    if (loading) {
      return
    }

    setLoading(true)
    setSelectedProcessToCopy(sourceProcessId)

    try {
      const copyResponse = await copyProcessConfiguration(stepOneData.processId, Number(sourceProcessId))

      if (copyResponse.status === 'error') {
        getWarning(String(copyResponse.error || 'No fue posible copiar la parametrización del proceso'))
        setSelectedProcessToCopy('')
        return
      }

      const processDetailResponse = (await getProcessDetail(stepOneData.processId)) as any
      if (processDetailResponse.status === 'error' || !processDetailResponse.process) {
        getWarning('La configuración se copió, pero no fue posible cargar el nuevo proceso')
        setSelectedProcessToCopy('')
        return
      }

      handleFinishProcess(processDetailResponse.process)
    } catch (error: any) {
      const backendMessage = error?.response?.data?.message
      getWarning(backendMessage || error?.message || 'No fue posible copiar la parametrización del proceso')
      setSelectedProcessToCopy('')
    } finally {
      setLoading(false)
    }
  }

  const handleSelectConfigurationOption = (optionKey: ConfigurationOption['key']) => {
    dispatch(cleanStepsFromThree())

    if (optionKey === 'ai') {
      setIsAiConfigurationSelected(true)
      setIsSelectedRoleFamily(null)
      setIsCopyConfigurationSelected(false)
      return
    }

    if (optionKey === 'manual') {
      setIsAiConfigurationSelected(false)
      setIsSelectedRoleFamily(false)
      setIsCopyConfigurationSelected(false)
      return
    }

    if (optionKey === 'role-family') {
      setIsAiConfigurationSelected(false)
      setIsSelectedRoleFamily(true)
      setIsCopyConfigurationSelected(false)
      return
    }

    setIsAiConfigurationSelected(false)
    setIsSelectedRoleFamily(null)
    setIsCopyConfigurationSelected(true)
  }

  return (
    <MainLayout>
      <Container>
        <HeaderContainer>
          <HeaderTextBlock>
            <StepEyebrow>Paso {currentStepIndex + 1}</StepEyebrow>
            <H2 margin="0">{currentStepTitle}</H2>
            <StepDescription>{currentStepDescription}</StepDescription>
          </HeaderTextBlock>
          <Stepper activeStep={currentStepIndex} steps={STEPS_NEW_PROCESS} />
        </HeaderContainer>
        <Content>
          <SelectorsContainer>
            <IntroBlock>
              <IntroTitle>Elige cómo quieres configurar este proceso</IntroTitle>
              <IntroText>
                Puedes apoyarte en una estructura existente, construirlo manualmente
                o dejar que Bluesite Lumina te sugiera un perfil ideal inicial.
              </IntroText>
            </IntroBlock>

            <OptionsGrid>
              {configurationOptions.map((option) => {
                const isSelected =
                  (option.key === 'ai' && isAiConfigurationSelected) ||
                  (option.key === 'manual' &&
                    isSelectedRoleFamily === false &&
                    !isAiConfigurationSelected &&
                    !isCopyConfigurationSelected) ||
                  (option.key === 'role-family' &&
                    isSelectedRoleFamily === true &&
                    !isAiConfigurationSelected &&
                    !isCopyConfigurationSelected) ||
                  (option.key === 'copy' && isCopyConfigurationSelected)

                return (
                  <OptionCard
                    key={option.key}
                    type="button"
                    $selected={isSelected}
                    $accent={option.accent}
                    onClick={() => handleSelectConfigurationOption(option.key)}
                  >
                    <OptionEyebrow>{option.eyebrow}</OptionEyebrow>
                    <OptionHeader>
                      <OptionTitle>{option.title}</OptionTitle>
                      <OptionMeta>
                        {option.badge && <OptionBadge>{option.badge}</OptionBadge>}
                        <OptionIndicator
                          $selected={isSelected}
                          $accent={option.accent}
                        />
                      </OptionMeta>
                    </OptionHeader>
                    <OptionDescription>{option.description}</OptionDescription>
                  </OptionCard>
                )
              })}
            </OptionsGrid>
          </SelectorsContainer>
          {isCopyConfigurationSelected && (
            <OptionSupportBlock>
              <Box sx={{ width: '100%', maxWidth: '440px', padding: '8px 0 28px 0' }}>
                <SelectSearch
                  label="Copiar parametrización de otro proceso"
                  options={processesToCopy}
                  value={selectedProcessToCopy}
                  onChange={(value) => {
                    setSelectedProcessToCopy(value)
                    const selectedProcess = processesToCopy.find((process) => process.value === value) || null
                    setPendingProcessToCopy(selectedProcess)
                  }}
                  showCheckboxes={false}
                  maxWidth="100%"
                  width="100%"
                  disabled={loading}
                />
              </Box>
            </OptionSupportBlock>
          )}
          {isSelectedRoleFamily && !isAiConfigurationSelected && (
            <InfoRoleFamilyContainer
              onEditRoleFamily={(e) => {
                setRoleFamily(e)
              }}
              defaultRole={nameRoleFamilySelected}
              onSelectRole={(e: string) => {
                // Si se selecciona una familia de rol diferente, limpiar estados posteriores
                if (e !== nameRoleFamilySelected) {
                  dispatch(cleanStepsFromThree())
                }
                setNameRoleFamilySelected(e)
              }}
              options={roleFamilies}
              onChangeEditingRoleFamily={(e: boolean) => setEditingRoleFamily(e)}
            />
          )}
          {!isSelectedRoleFamily && <></>}
        </Content>
        {editingRoleFamily !== true && !isSelectedRoleFamily && !isAiConfigurationSelected && !isCopyConfigurationSelected && (
          <FooterContent>
            <BackButton onClick={() => navigate(platformAdminRoutes.CreateProcess)} />
            <Button
              disabled={
                (isRoleFamilySelected === true || isSelectedRoleFamily === null) && isSelectedRoleFamily !== false
              }
              onClick={() => (!isSelectedRoleFamily ? handleCreateProcessFromScratch() : null)}
              style={{
                padding: '10px 20px',
              }}
              type="button"
            >
              {isSelectedRoleFamily ? t('global.common.nextButtonText') : 'Selección de pruebas'}
            </Button>
          </FooterContent>
        )}
        {isCopyConfigurationSelected && (
          <FooterContent>
            <BackButton onClick={() => navigate(platformAdminRoutes.CreateProcess)} />
            <Button
              disabled={!selectedProcessToCopy}
              type="button"
              onClick={() => {
                const selectedProcess =
                  processesToCopy.find((process) => process.value === selectedProcessToCopy) || pendingProcessToCopy

                if (!selectedProcess) {
                  return
                }

                setPendingProcessToCopy(selectedProcess)
                setShowConfirmCopyModal(true)
              }}
            >
              Copiar parametrización
            </Button>
          </FooterContent>
        )}
        {isAiConfigurationSelected && (
          <FooterContent>
            <BackButton onClick={() => navigate(platformAdminRoutes.CreateProcess)} />
            <Button
              type="button"
              onClick={handleCreateProcessWithAI}
              style={{
                padding: '10px 20px',
              }}
            >
              Generar perfil ideal
            </Button>
          </FooterContent>
        )}
        {isSelectedRoleFamily && !editingRoleFamily && (
          <FooterContent>
            <BackButton
              onClick={() => {
                if (hasEditedRoleFamily || (stepTwoData.roleFamilyName && stepFourData.processId)) {
                  setShowModalConfirmDeleteEditedRoleFamily(true)
                } else {
                  navigate(platformAdminRoutes.CreateProcess, { replace: true })
                }
              }}
            />
            <Button
              disabled={!nameRoleFamilySelected}
              type="submit"
              onClick={handleCreateProcessWithRoleFamily}
              onDisabledClick={() => {
                setShowAlert(true)
                setTimeout(() => {
                  setShowAlert(false)
                }, 3000)
              }}
            >
              {t('global.common.nextButtonText')}
            </Button>
          </FooterContent>
        )}
      </Container>
      {showModalConfirmDeleteEditedRoleFamily && (
        <ModalConfirmDeleteEditedRoleFamily
          visible={showModalConfirmDeleteEditedRoleFamily}
          onAccept={() => {
            // Limpiar estados al volver atrás después de editar familia de rol
            dispatch(cleanStepsFromThree())
            dispatch(setLoadingProcess(false))
            navigate(platformAdminRoutes.CreateProcess, { replace: true })
          }}
          onCancel={() => setShowModalConfirmDeleteEditedRoleFamily(false)}
        />
      )}
      {showConfirmCopyModal && pendingProcessToCopy && (
        <ModalConfirmCopyProcess
          visible={showConfirmCopyModal}
          processName={pendingProcessToCopy.label}
          onAccept={() => {
            setShowConfirmCopyModal(false)
            setSelectedProcessToCopy(pendingProcessToCopy.value)
            handleCopyConfiguration(pendingProcessToCopy.value)
          }}
          onCancel={() => {
            setShowConfirmCopyModal(false)
            setPendingProcessToCopy(null)
          }}
        />
      )}
      <ModalLoader isLoading={loading} />
      <AlertComponent message="Primero debes seleccionar una familia de rol" severity="warning" open={showAlert} />
    </MainLayout>
  )
}

export default RoleFamily
